import { useRef, useState } from 'react';

import { NavLink } from 'react-router-dom';

import {
  Avatar,
  Box,
  Button,
  Collapse,
  Divider,
  Hidden,
  lighten,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
  Typography
} from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router';
import InboxTwoToneIcon from '@mui/icons-material/InboxTwoTone';
import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import AccountBoxTwoToneIcon from '@mui/icons-material/AccountBoxTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone';
import { AmacUrl } from 'src/common/routes';
import { deepPurple } from '@mui/material/colors';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import DescriptionIcon from '@mui/icons-material/Description';
import BarChartIcon from '@mui/icons-material/BarChart';
import MapIcon from '@mui/icons-material/Map';
import Groups2Icon from '@mui/icons-material/Groups2';
import BallotIcon from '@mui/icons-material/Ballot';
import Axios, { API } from 'src/common/api';
import PeopleIcon from '@mui/icons-material/People';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import ContactsIcon from '@mui/icons-material/Contacts';
import { useGlobalState } from 'src/state/globalstate';
import HubIcon from '@mui/icons-material/Hub';

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);

function HeaderUserbox() {
  let navigate = useNavigate();
  const { state } = useParams();

  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);
  const email = localStorage.getItem('email');
  const Access_State = localStorage.getItem('Access_State');

  const userRole = localStorage.getItem('Access_Urm');
  const RelationAccessListing = useGlobalState('RelationAccessListing');

  
  let role = 'Volunteer';

  if (userRole == '1') {
    role = 'Super Admin';
  } else if (userRole == '2') {
    role = 'Admin';
  } else if (userRole == '3') {
    role = 'Captain';
  } else if (userRole == '4') {
    role = 'Volunteer';
  }

  const user = {
    name: localStorage.getItem('username'),
    avatar: '/static/images/avatars/7.png',
    jobtitle: role
  };

  const [openMenus, setOpenMenus] = useState({});

  const handleToggle = (menuKey) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  };

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const Logoutuser = async () => {
    const rememberCheck = localStorage.getItem('rememberCheck');
    const rememberuser = localStorage.getItem('rememberuser');
    const selectedLanguage = localStorage.getItem('language');
    const languageType = localStorage.getItem('languageType');
    localStorage.clear();
    localStorage.setItem('language', selectedLanguage);
    localStorage.setItem('languageType', languageType);
    navigate(`/${AmacUrl.Login}`);
    localStorage.setItem('rememberCheck', rememberCheck);
    localStorage.setItem('rememberuser', rememberuser);
    setOpen(false);
    try {
      await Axios.get(API.logout).then((res) => {
        // store the data into our books variable
        // const LogoutArray = res.data;
        // console.log('Logout Called ===');
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Avatar variant="rounded" alt={user.name} src={user.avatar} />
        {/* <Avatar sx={{ bgcolor: deepPurple[500] }}>A</Avatar> */}
        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">{user.name}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {user.jobtitle}
            </UserBoxDescription>
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          <Avatar variant="rounded" alt={user.name} src={user.avatar} />
          <UserBoxText>
            <UserBoxLabel variant="body1">{user.name}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {user.jobtitle}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        <List sx={{ p: 1 }} component="nav">
          <ListItem
            button
            to={`/${state}/${AmacUrl.Dashboard}`}
            component={NavLink}
            onClick={handleClose}
          >
            <HowToVoteIcon fontSize="small" />
            <ListItemText primary="Voters Data" />
          </ListItem>
          {Access_State == 'wa' ? (
            <>
              <List sx={{ pt: 0, pb: 0 }}>
                {/* Elections Analytics Parent Item */}
                <ListItem
                  button
                  onClick={() => handleToggle('analytics')}
                  sx={{ pl: 1 }}
                >
                  <ListItemIcon
                    style={{ minWidth: 'max-content' }}
                    sx={{ pr: 1 }}
                  >
                    <AnalyticsIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Elections Analytics" />
                  {openMenus['analytics'] ? <ExpandLess /> : <ExpandMore />}
                </ListItem>

                {/* Sub-options for Elections Analytics */}
                <Collapse
                  in={openMenus['analytics']}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      component={NavLink}
                      to={`/${state}/${AmacUrl.GeneralElections2024}`}
                      onClick={handleClose}
                      sx={{ pl: 4 }}
                    >
                      <ListItemText primary="2024 General Elections" />
                    </ListItem>
                    <ListItem
                      button
                      component={NavLink}
                      to={`/${state}/${AmacUrl.PrimaryElections2025}`}
                      onClick={handleClose}
                      sx={{ pl: 4 }}
                    >
                      <ListItemText primary="2025 Primary Elections" />
                    </ListItem>
                    <ListItem
                      button
                      component={NavLink}
                      to={`/${state}/${AmacUrl.PrimaryElectionsNov2025}`}
                      onClick={handleClose}
                      sx={{ pl: 4 }}
                    >
                      <ListItemText primary="Nov 2025 Elections" />
                    </ListItem>
                  </List>
                </Collapse>

                {/* Repeat for other expandable menus */}
                {/* Example:
        <ListItem button onClick={() => handleToggle('reports')}>
          ...
        </ListItem>
        <Collapse in={openMenus['reports']} timeout="auto" unmountOnExit>
          ...
        </Collapse>
      */}
              </List>
            </>
          ) : (
            <>
              <ListItem
                button
                to={`/${state}/${AmacUrl.Analytics}`}
                component={NavLink}
                onClick={handleClose}
              >
                <AnalyticsIcon fontSize="small" />
                <ListItemText primary="Analytics" />
              </ListItem>
            </>
          )}
          {/* <ListItem
            button
            to={`/${state}/${AmacUrl.Analytics}`}
            component={NavLink}
            onClick={handleClose}
          >
            <AnalyticsIcon fontSize="small" />
            <ListItemText primary="Analytics" />
          </ListItem> */}

          {/* <ListItem
            button
            to={AmacUrl.ChorplethMap}
            component={NavLink}
            onClick={handleClose}
          >
            <MapIcon fontSize="small" />
            <ListItemText primary="Chorpleth Maps" />
          </ListItem> */}
          {RelationAccessListing[0]?.includes(email) && Access_State == 'wa' ? (
            <>
              <ListItem
                button
                to={`/${state}/${AmacUrl.CaptainsRelations}`}
                component={NavLink}
                onClick={handleClose}
              >
                <HubIcon fontSize="small" />
                <ListItemText primary="Captains Relations" />
              </ListItem>
              
            </>
          ) : (
            ''
          )}

          {userRole == '1' ? (
            <>
              <ListItem
                button
                to={`/${state}/${AmacUrl.LoginLogs}`}
                component={NavLink}
                onClick={handleClose}
              >
                <DescriptionIcon fontSize="small" />
                <ListItemText primary="Voters Listing Logs" />
              </ListItem>
              <ListItem
                button
                to={`/${state}/${AmacUrl.CandidatesLogs}`}
                component={NavLink}
                onClick={handleClose}
              >
                <HowToRegIcon fontSize="small" />
                <ListItemText primary="Candidates Logs" />
              </ListItem>
              
            </>
          ) : (
            ''
          )}

          {userRole == '1' || userRole == '2' ? (
            <>
              <ListItem
                button
                to={`/${state}/${AmacUrl.UsersManagement}`}
                component={NavLink}
                onClick={handleClose}
              >
                <GroupsIcon fontSize="small" />
                <ListItemText primary="Users Management" />
              </ListItem>
              <ListItem
                button
                to={`/${state}/${AmacUrl.Contacts}`}
                component={NavLink}
                onClick={handleClose}
              >
                <ContactsIcon fontSize="small" />
                <ListItemText primary="Contacts" />
              </ListItem>
            </>
          ) : (
            ''
          )}

          {/* <ListItem
                button
                to={AmacUrl.Voters}
                component={NavLink}
                onClick={handleClose}
              >
                <PersonSearchIcon fontSize="small" />
                <ListItemText primary="Search Voters - Postgres" />
              </ListItem> */}
          {/* <ListItem
                button
                to={AmacUrl.SearchUserClickHouse}
                component={NavLink}
                onClick={handleClose}
              >
                <PersonSearchIcon fontSize="small" />
                <ListItemText primary="Voters Data - Old" />
              </ListItem>
              <ListItem
                button
                to={AmacUrl.VotersListingLogs}
                component={NavLink}
                onClick={handleClose}
              >
                <DescriptionIcon fontSize="small" />
                <ListItemText primary="Voters Listing Logs - Old" />
              </ListItem> */}
          <ListItem
            button
            to={`/${state}/${AmacUrl.VoterTurnout}`}
            component={NavLink}
            onClick={handleClose}
          >
            <MapIcon fontSize="small" />
            <ListItemText primary="Voters Turnout" />
          </ListItem>
          <ListItem
            button
            to={`/${state}/${AmacUrl.VoterPopulation}`}
            component={NavLink}
            onClick={handleClose}
          >
            <BallotIcon fontSize="small" />
            <ListItemText primary="Voters Population" />
          </ListItem>
          <ListItem
            button
            to={`/${state}/${AmacUrl.CommunityDemographics}`}
            component={NavLink}
            onClick={handleClose}
          >
            <PeopleIcon fontSize="small" />
            <ListItemText primary="Community Demographics" />
          </ListItem>

        </List>
        <Divider />

        <Box sx={{ m: 1 }}>
          <Button color="primary" fullWidth onClick={Logoutuser}>
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
